import { defineMessages } from "../i18n/core";

export const loginMessages = defineMessages({
  "pt-BR": {
    headline: "Cada máquina, cada dia, um ponto de restauração.",
    noAccount: "Ainda não tem conta?",
    trialLink: "Teste grátis por 30 dias",
    pitch: "Veja em segundos o que está protegido e o que não está. Restaure um arquivo ou uma máquina inteira a partir do mesmo lugar, para todos os seus clientes.",
    stripCaption: "Exemplo · srv-arquivos-01 · últimos 30 dias",
    title: "Entrar na console",
    lede: "Use o e-mail da sua conta E-BACKUP.",
    email: "E-mail",
    password: "Senha",
    mockPassword: "No mock, qualquer senha com 8 caracteres ou mais é aceita.",
    checking: "Verificando…",
    continue: "Continuar",
    loginFailed: "Não foi possível entrar agora.",
    totpTitle: "Verificação em duas etapas",
    totpLede: "Digite o código de 6 dígitos do seu aplicativo autenticador.",
    code: "Código",
    mockCode: "No mock, qualquer sequência de 6 dígitos é aceita.",
    validating: "Validando…",
    signIn: "Entrar",
    totpFailed: "Não foi possível validar o código.",
    enrollTitle: "Cadastre o autenticador",
    enrollLede: "É o seu primeiro acesso, ou a verificação em duas etapas da sua conta foi redefinida. Adicione o E-BACKUP a um aplicativo autenticador (Microsoft Authenticator, Google Authenticator, 1Password) escaneando o QR code.",
    enrollAccount: (email: string) => `No aplicativo, a conta aparece como E-BACKUP (${email}).`,
    qrLabel: "QR code para o aplicativo autenticador",
    manualKey: "Sem câmera? Digite esta chave no aplicativo:",
    secretLabel: "chave do autenticador",
    enrollCode: "Código que o aplicativo mostra",
    enrollExpiry: "Este QR code vale por 5 minutos. Se expirar, volte e entre de novo para gerar outro.",
    enrollSubmit: "Confirmar e entrar",
    mockEnroll: "Para ver o cadastro do autenticador, entre como auditoria@contabilexemplo.com.br.",
  },
  "en-US": {
    headline: "Every machine, every day, a restore point.",
    noAccount: "Don't have an account yet?",
    trialLink: "Try it free for 30 days",
    pitch: "See in seconds what is protected and what is not. Restore a single file or an entire machine from the same place, for all your customers.",
    stripCaption: "Sample · srv-arquivos-01 · last 30 days",
    title: "Sign in to the console",
    lede: "Use the email of your E-BACKUP account.",
    email: "Email",
    password: "Password",
    mockPassword: "In the mock, any password with 8 or more characters is accepted.",
    checking: "Checking…",
    continue: "Continue",
    loginFailed: "Could not sign in right now.",
    totpTitle: "Two-step verification",
    totpLede: "Enter the 6-digit code from your authenticator app.",
    code: "Code",
    mockCode: "In the mock, any 6-digit sequence is accepted.",
    validating: "Verifying…",
    signIn: "Sign in",
    totpFailed: "Could not verify the code.",
    enrollTitle: "Set up your authenticator",
    enrollLede: "This is your first sign-in, or two-step verification was reset for your account. Add E-BACKUP to an authenticator app (Microsoft Authenticator, Google Authenticator, 1Password) by scanning the QR code.",
    enrollAccount: (email: string) => `In the app, the account shows as E-BACKUP (${email}).`,
    qrLabel: "QR code for the authenticator app",
    manualKey: "No camera? Enter this key in the app:",
    secretLabel: "authenticator key",
    enrollCode: "Code shown in the app",
    enrollExpiry: "This QR code is valid for 5 minutes. If it expires, go back and sign in again to get a new one.",
    enrollSubmit: "Confirm and sign in",
    mockEnroll: "To see authenticator setup, sign in as auditoria@contabilexemplo.com.br.",
  },
  es: {
    headline: "Cada equipo, cada día, un punto de restauración.",
    noAccount: "¿Aún no tienes cuenta?",
    trialLink: "Prueba gratis durante 30 días",
    pitch: "Ve en segundos qué está protegido y qué no. Restaura un archivo o un equipo completo desde el mismo lugar, para todos tus clientes.",
    stripCaption: "Ejemplo · srv-arquivos-01 · últimos 30 días",
    title: "Iniciar sesión en la consola",
    lede: "Usa el correo de tu cuenta de E-BACKUP.",
    email: "Correo electrónico",
    password: "Contraseña",
    mockPassword: "En el mock se acepta cualquier contraseña de 8 caracteres o más.",
    checking: "Verificando…",
    continue: "Continuar",
    loginFailed: "No se pudo iniciar sesión en este momento.",
    totpTitle: "Verificación en dos pasos",
    totpLede: "Escribe el código de 6 dígitos de tu app de autenticación.",
    code: "Código",
    mockCode: "En el mock se acepta cualquier secuencia de 6 dígitos.",
    validating: "Validando…",
    signIn: "Iniciar sesión",
    totpFailed: "No se pudo validar el código.",
    enrollTitle: "Registra tu app de autenticación",
    enrollLede: "Es tu primer acceso, o se restableció la verificación en dos pasos de tu cuenta. Agrega E-BACKUP a una app de autenticación (Microsoft Authenticator, Google Authenticator, 1Password) escaneando el código QR.",
    enrollAccount: (email: string) => `En la app, la cuenta aparece como E-BACKUP (${email}).`,
    qrLabel: "Código QR para la app de autenticación",
    manualKey: "¿Sin cámara? Escribe esta clave en la app:",
    secretLabel: "clave de autenticación",
    enrollCode: "Código que muestra la app",
    enrollExpiry: "Este código QR es válido por 5 minutos. Si vence, vuelve e inicia sesión de nuevo para generar otro.",
    enrollSubmit: "Confirmar e iniciar sesión",
    mockEnroll: "Para ver el registro de la app de autenticación, inicia sesión como auditoria@contabilexemplo.com.br.",
  },
});
